(function($) {
	"use strict";

	var langs = {
		fr: {
			popinTitle : 'Prendre la photo',
		},
		en: {
			popinTitle : 'Take photo',
		},
		de: {
			popinTitle : 'Foto machen',
		}
	};

	function available() {
		return navigator.getUserMedia || (navigator.mediaDevices ? navigator.mediaDevices.getUserMedia : false) || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
	}

	function popin(options) {
		var lang = langs[options.lang];
		var div = $('<div />').append(''
				+ '<div style="display:block; position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: 50px; padding: 0px">'
				+ '  <video playsinline style="display: block; margin: auto; width: 100%;" />'
				+ '</div>'
				+ '<canvas style="display: none;" />');
		var video = div.find('video')[0];
		var canvas = div.find('canvas')[0];
		var modes, index, stream;

		// Afficher le popin
		div.materialPopin({
			title : lang.popinTitle,
			onclose: closeStream,
			buttons : [{
				icon : 'refresh',
				visible : false,
				onclick : function() {
					// Inversion entre caméra avant et arrière
					closeStream();
					index = (index + 1) % modes.length;
					openStream();
				}
			}, {
				icon : 'done',
				visible : true,
				onclick : function() {
					var canvasWidth = video.videoWidth;
					var canvasHeight = video.videoHeight;
					// On aggrandit le canvas à la taille de la vidéo.
					if (options.limit && (video.videoWidth > options.limit || video.videoHeight > options.limit)) {
						if (canvasWidth > canvasHeight) {
							canvasWidth = options.limit;
							canvasHeight = video.videoHeight * (options.limit / video.videoWidth);
						} else {
							canvasWidth = video.videoWidth * (options.limit / video.videoHeight);
							canvasHeight = options.limit;
						}
					}

					canvas.setAttribute('width', canvasWidth);
					canvas.setAttribute('height', canvasHeight);
					canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight, 0, 0, canvasWidth, canvasHeight);
					var data = canvas.toDataURL('image/jpeg');
					video.pause();

					// Effet prise de photo
					animatePhoto(video, function() {
						// On ferme le popin de prise de photo aussitôt
						div.materialPopin('close');
						// On prévient l'appelant en lui filant la photo sous la forme d'une dataURL
						options.callback(data);
					});
				}
			}]
		});

		// Afficher avec une caméra
		function openStream() {
			getUserMedia({
				video: modes[index], // { deviceId: '...' } ou { facingMode: 'environment' } ou { facingMode: 'user' } ou juste true
				audio: false
			}, function successCallback(s) {
				stream = s;
				if (video.mozSrcObject !== undefined) { // Anciens Firefox
					video.mozSrcObject = stream;
				} else if (video.srcObject !== undefined) { // Chrome / Safari / Firefox
					video.srcObject = stream;
				} else { // IE / Edge
					var vendorURL = window.URL || window.webkitURL;
					video.src = vendorURL.createObjectURL(stream);
				}
				video.play();
			}, function errorCallback(error) {
				// On prévient l'appelant qu'aucune photo n'a été prise
				options.callback(undefined);
				// On ferme le popin de prise de photo
				div.materialPopin('close');
			});
		}

		// Fermer le flux video ouvert (qd on switch, qd on valide ou qd on annule)
		function closeStream() {
			if (!! stream) {
				stream.getTracks().forEach(function(track) {
					track.stop();
				});
			}
		}

		// C'est parti
		enumModes(function(list) {
			modes = list;
			index = 0;
			openStream();
			if (modes.length >= 2)
				div.trigger('setbuttons', ['refresh done clear']);
		});
	}

	// Rechercher les caméras
	function enumModes(callback) {
		// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/enumerateDevices
		if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
			navigator.mediaDevices.enumerateDevices().then(function(list) {
				// Ne garder que les entrées vidéos
				// https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo
				list = list.filter(function(device) {
					return device.kind === 'videoinput';
				});
				// Vérifier si "facingMode" est supporté et proposer en priorité la caméra arrière s'il y a plusieurs périphériques
				// https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getSupportedConstraints
				if (list.length >= 2
						&& navigator.mediaDevices.getSupportedConstraints
						&& 'facingMode' in navigator.mediaDevices.getSupportedConstraints()) {
					// https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/facingMode
					callback([
						{ facingMode: 'environment' },
						{ facingMode: 'user' }
					]);
				} else {
					// https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints/deviceId
					callback(list.map(function(device) {
						return { deviceId: device.deviceId };
					}));
				}

			}, function() {
				callback([true]);
			});
		} else {
			callback([true]);
		}
	}

	// Cette méthode de WebRTC tente d'accéder à la webcam et appelle l'une des callback en cas de succès ou d'erreur
	function getUserMedia(constraints, successCallback, errorCallback) {
		// Nouvelles APIs basées sur MediaDevices
		if (navigator.mediaDevices.getUserMedia)
			navigator.mediaDevices.getUserMedia(constraints).then(successCallback, errorCallback);
		else {
			navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
			if (navigator.getUserMedia)
				navigator.getUserMedia(constraints, successCallback, errorCallback);
			else
				errorCallback('WebRTC is not available');
		}
	}

	// Cette fonction lance une animation jQuery pour indiquer la prise de photo
	// - la taille diminue brièvement (200ms) puis revient à la taille d'origine (200ms)
	// => l'utilisateur sait que la photo a été prise
	// - on attend ensuite encore un peu (600ms)
	// => l'utilisateur aperçoit rapidement le résultat avant qu'on ferme le popin
	function animatePhoto(video, callback) {
		var v = $(video);
		v.animate({
			'width': '60%',
		}, 200, function() {
			v.animate({
				'width': '100%',
			}, 200, function() {
				setTimeout(callback, 600);
			});
		});
	}

	$.photo = {
		langs: langs,
		available: available,
		popin: popin
	};

})(window.jQuery);
